<!-- 出口保税核注 -->
 <template>
    <div>
        <bondedApproval ref="bondedApproval" :exportCode="type"></bondedApproval>
    </div>
</template>
<script>
import bondedApproval from '@/components/AEO/invt/bondedApproval.vue'

export default {
    name: 'invtExport',
    components:{
        bondedApproval
    },
    watch: {
        '$route'(to, from) {
            // 路由变化时执行逻辑
            if (!this.eventBusDataReceived) { // 标志位，避免重复触发
                this.$nextTick(() => {
                    if (this.$refs.bondedApproval) {
                        const { id = ''} = to.query;
                        this.$refs.bondedApproval.getdeclareDetails(id, false);
                    }
                });
            }
            this.eventBusDataReceived = false; // 重置标志位
        }
    },
    data() {
        return {
            type:'E',
            eventBusDataReceived:false,
        }
    },
    created() {
        this.$eventBus.$on('data-invtID', (data) => {
            this.eventBusDataReceived = true; // 标记已接收 EventBus 数据
            this.copyExportID(data);
        });
    },
    mounted() {
        this.$refs.bondedApproval.getdeclareDetails(this.$route.query.id)
    },
    methods: {
        copyExportID(data){
            this.$refs.bondedApproval.getdeclareDetails(data.id,true)
        }
    },
    beforeDestroy() {
        // 移除监听，避免内存泄漏！
        this.$eventBus.$off('data-invtID', this.copyExportID);
    },
}
</script>
<style lang="css" scoped>
</style>
